<template>
  <div class="OrderShow" >
    <div class="OrderShow_body">
      <h3 class="title w-700">预约免费演示</h3>
      <div class="main">
        <div class="input-box box1">
          <div class="bg1">
          </div>
          <input class="input" type="text" placeholder="请输入您的真实姓名">
        </div>
        <div class="input-box box1">
          <div class="bg2">
          </div>
          <input class="input" type="text" placeholder="请输入您所在的企业名称">
        </div>
        <div class="input-box2">
          <div class="left-phone">
            <select id="phone" class="sel">
              <option>+86</option>
              <option>+88</option>
            </select>
            <img src="../../../assets/images/home/orderShow/sel.png" alt="">
          </div>
          <input class="input sclec" type="text" placeholder="输入您的手机号">
          <div></div>
        </div>
        <div class="input-box3 box1">
          <div class="bg3">
          </div>
          <input class="input code-input" type="text" placeholder="请输入验证码">
          <div class="code">获取验证码</div>
        </div>
      </div>
      <div class="btn fs-3">
        立即提交
      </div>
      <div class="text">*预约成功后，我们会联系您并预约演示时间</div>
    </div>
    <div class="close" @click="close"><i class="bi bi-x-lg search_header"></i></div>
  </div>
</template>
<script>
export default {
  name: 'OrderShow',
  data() {
    return {
      show:this.$route.query.aaa
    }
  },
  mounted(){
    // if (!this.$route.query.aaa) {
    //   window.location.href=window.location.href+'?aaa=1'
    // }
    console.log(this.$route,'7987');
  },
  methods: {
    close(){
      this.$emit('close')
    },
    abc(){
      
    }
  }

}
</script>
<style lang="scss">
.OrderShow{
  position: fixed;
  top:50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  background: #fff;
  .OrderShow_body{
    width: 640px;
    height: 670px;
    padding: 80px;
    .main{
      .bg1,.bg2,.bg3{
        position: absolute;
        top: 32px;
        left: 23px;
      }
      .bg1{
        background: url('../../../assets/images/home/orderShow/name.png') no-repeat center;
        width: 14px;
        height: 16px;
      }
      .bg2{
        background: url('../../../assets/images/home/orderShow/qiye.png') no-repeat center;
        width: 14px;
        height: 16px;
      }
      .bg3{
        background: url('../../../assets/images/home/orderShow/yanzhengma.png') no-repeat center;
        width: 14px;
        height: 16px;
      }
      .input{
        width: 480px;
        height: 60px;
        padding-left: 50px;
        margin: 10px 0;
      }
      .box1{
        //display: flex;
        //align-items: center;
        position: relative;
      }
      .input-box{

      }
      .input-box2{
        position: relative;
        .left-phone{
          position: absolute;
          top: 21px;
          left: 15px;
        }
        .sel{
          width: 40px;
          height: 40px;
          padding: 0;
        }
        .sclec{
          padding-left: 90px;

        }
      }
      .input-box3{
        .code-input{
          padding-right: 150px;
        }
        .code{
          width: 140px;
          height: 30px;
          text-align: center;
          border-left: 1px solid #e8e8e8;
          position: absolute;
          top: 25px;
          right: 0;
          color: #1865cd;
          cursor: pointer;
        }
      }
    }
    .btn{
      width: 480px;
      height: 60px;
      background: #1865d7;
      border-radius: 10px;
      color: #fff;
      text-align: center;
      line-height: 60px;
      margin: 20px 0;
      cursor: pointer;
    }
    .text{
      color: #1865cd;
    }
  }
  .close{
    position: absolute;
    top: 14%;
    right: 13%;
    cursor: pointer;
  }
}
</style>
